export const featuredJobs = [
  {
    id: 1,
    title: "Senior Software Engineer",
    company: "TechVision Corp",
    logo: "https://public.readdy.ai/ai/img_res/5b2e584e580b55e9e790b977465236a4.jpg",
    location: "New York, NY",
    salary: "$120,000 - $160,000",
    type: "Full-time",
    industry: "Technology",
    posted: "2 hours ago",
    urgent: true,
  },
  {
    id: 2,
    title: "Marketing Manager",
    company: "BrandPulse Agency",
    logo: "https://readdy.ai/api/search-image?query=marketing%20agency%20logo%20orange%20wave%20minimalist%20clean&width=80&height=80&seq=job2&orientation=squarish",
    location: "Los Angeles, CA",
    salary: "$85,000 - $110,000",
    type: "Full-time",
    industry: "Marketing",
    posted: "5 hours ago",
    urgent: false,
  },
  {
    id: 3,
    title: "Financial Analyst",
    company: "Crown Capital Group",
    logo: "https://readdy.ai/api/search-image?query=finance%20company%20logo%20gold%20crown%20minimalist%20professional&width=80&height=80&seq=job3&orientation=squarish",
    location: "Chicago, IL",
    salary: "$75,000 - $95,000",
    type: "Full-time",
    industry: "Finance",
    posted: "1 day ago",
    urgent: false,
  },
  {
    id: 4,
    title: "UX/UI Designer",
    company: "PixelCraft Studio",
    logo: "https://readdy.ai/api/search-image?query=design%20studio%20logo%20purple%20diamond%20minimalist%20creative&width=80&height=80&seq=job4&orientation=squarish",
    location: "Remote",
    salary: "$90,000 - $120,000",
    type: "Remote",
    industry: "Design",
    posted: "2 days ago",
    urgent: true,
  },
  {
    id: 5,
    title: "Operations Director",
    company: "LogiFlow Solutions",
    logo: "https://readdy.ai/api/search-image?query=logistics%20company%20logo%20green%20arrow%20minimalist%20professional&width=80&height=80&seq=job5&orientation=squarish",
    location: "Houston, TX",
    salary: "$130,000 - $170,000",
    type: "Full-time",
    industry: "Logistics",
    posted: "3 days ago",
    urgent: false,
  },
  {
    id: 6,
    title: "Data Scientist",
    company: "Analytix AI",
    logo: "https://readdy.ai/api/search-image?query=AI%20data%20company%20logo%20teal%20hexagon%20minimalist%20tech&width=80&height=80&seq=job6&orientation=squarish",
    location: "San Francisco, CA",
    salary: "$140,000 - $180,000",
    type: "Full-time",
    industry: "Technology",
    posted: "4 days ago",
    urgent: false,
  },
];

export const jobCategories = [
  { name: "Technology", count: 1842, icon: "ri-computer-line" },
  { name: "Finance", count: 934, icon: "ri-bank-line" },
  { name: "Healthcare", count: 1205, icon: "ri-heart-pulse-line" },
  { name: "Marketing", count: 678, icon: "ri-megaphone-line" },
  { name: "Education", count: 512, icon: "ri-graduation-cap-line" },
  { name: "Logistics", count: 743, icon: "ri-truck-line" },
  { name: "Real Estate", count: 389, icon: "ri-building-line" },
  { name: "Hospitality", count: 621, icon: "ri-hotel-line" },
];
